import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { and } from 'airbnb-prop-types';
import classNames from 'classnames';
import ActionBlock from '@nerdwallet/react-action-block';
import { withDeprecatedPropsWarning } from '@nerdwallet/deprecate';
import styles from './checkbox.module.less';
/**
 * Custom prop type validator that checks string length.
 */

var maxLineLength = {};

maxLineLength.isRequired = function (props, propName) {
  var componentName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ANONYMOUS';

  if (props[propName]) {
    var value = props[propName];
    var maxChars = 70;

    if (typeof value === 'string') {
      return value.length <= maxChars ? null : new Error("Keep ".concat(propName, " in ").concat(componentName, " under ").concat(maxChars, " characters. Line length on ").concat(propName, " is ").concat(value.length - maxChars, " characters too long."));
    }
  }

  return null;
};

var BlockLabel = function BlockLabel(_ref) {
  var children = _ref.children,
      className = _ref.className,
      dangerouslyForceFocusStyling = _ref.dangerouslyForceFocusStyling,
      dangerouslyForceHoverStyling = _ref.dangerouslyForceHoverStyling,
      disabled = _ref.disabled;
  return /*#__PURE__*/React.createElement(ActionBlock, {
    dangerouslyForceHoverStyling: dangerouslyForceHoverStyling,
    dangerouslyForceFocusStyling: dangerouslyForceFocusStyling,
    component: "span",
    mode: "group",
    disabled: disabled,
    className: classNames([className, styles.label, styles['label--block']])
  }, children);
}; // eslint-disable-next-line react/prop-types


var InlineLabel = function InlineLabel(_ref2) {
  var className = _ref2.className,
      children = _ref2.children;
  return /*#__PURE__*/React.createElement("span", {
    className: classNames([className, styles.label, styles['label--inline']])
  }, children);
};
/**
 * The points in this line were derived geometrically from the outline of the
 * checkbox provided by design; they're not just magic numbers. We can't just
 * use the SVG asset directly because we need a single line to animate.
 */


var CheckPolyline = function CheckPolyline() {
  return /*#__PURE__*/React.createElement("polyline", {
    className: styles.check,
    points: "4.845,11.855 10.015,17.025 20.155,6.885"
  });
};
/**
 * A single checkbox option with label. Can be rendered in a block or inline.
 * Note that focusable="false" for the SVG below is necessary to avoid being tabbable on IE
 */


var CheckboxOption = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var className = props.className,
      dangerouslyForceFocusStyling = props.dangerouslyForceFocusStyling,
      dangerouslyForceHoverStyling = props.dangerouslyForceHoverStyling,
      disabled = props.disabled,
      id = props.id,
      inline = props.inline,
      label = props.label,
      otherProps = _objectWithoutProperties(props, ["className", "dangerouslyForceFocusStyling", "dangerouslyForceHoverStyling", "disabled", "id", "inline", "label"]);

  var LabelComponent = inline ? InlineLabel : BlockLabel;
  return /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    ref: ref
  }, /*#__PURE__*/React.createElement("input", _extends({
    type: "checkbox",
    disabled: disabled,
    className: styles.input,
    id: id
  }, otherProps)), /*#__PURE__*/React.createElement(LabelComponent, {
    className: className,
    disabled: disabled,
    dangerouslyForceFocusStyling: dangerouslyForceFocusStyling,
    dangerouslyForceHoverStyling: dangerouslyForceHoverStyling
  }, /*#__PURE__*/React.createElement("span", {
    className: styles['checkbox-wrapper']
  }, /*#__PURE__*/React.createElement("span", {
    className: styles['checkbox-back']
  }), /*#__PURE__*/React.createElement("svg", {
    focusable: "false",
    className: styles['checkbox-front'],
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    version: "1.1"
  }, /*#__PURE__*/React.createElement(CheckPolyline, null))), label));
});
CheckboxOption.displayName = 'CheckboxOption';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  CheckboxOption.propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    inline: PropTypes.bool,
    label: and([maxLineLength, PropTypes.node]).isRequired,

    /** Force the component to use its focus styles. */
    dangerouslyForceFocusStyling: PropTypes.bool,

    /** Force the component to use its hover styles. */
    dangerouslyForceHoverStyling: PropTypes.bool
  };
}

CheckboxOption.defaultProps = {
  className: null,
  disabled: false,
  id: null,
  inline: false,
  dangerouslyForceFocusStyling: false,
  dangerouslyForceHoverStyling: false
};
export default withDeprecatedPropsWarning([{
  version: '10.5.0',
  deprecated: 'inline',
  migration: 'Inline checkbox options are no longer recommended for use in designs.'
}])(CheckboxOption);